/**
 * Input box Component
 */
export * from './form-validator';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-inputs/src/form-validator/index.js
// module id = 1884
// module chunks = 0